<template>
	<page-content bgClass="bg-#0E0E0E" :triggered="triggered" :more="more" needMore @scrolltolower="scrolltolower"
		@refresherpulling="refresherpulling">
		<template v-slot:navBar>
			<home-nav :title="$t('NFT权益.NFT权益')" :showLang="true"></home-nav>
		</template>
		<template v-slot:content>

			<div class="px-30 pt-20 pb-140">
				<div class="nft-item1-bg-image p-30">
					<div class="flex items-center">
						<img class="w-88 h-88" src="@/assets/images/pages/nft/qyxt.png" alt="" />
						<div class="ml-20">
							<div>
								<span class="text-36 text-white">{{$t('NFT权益.NFT权益系统')}}</span>
							</div>
							<div class="mt-10">
								<span class="text-24 text-#999">{{$t('NFT权益.节点与矿机双重收益')}}</span>
							</div>
						</div>
					</div>
					<div class="mt-30  flex items-center justify-between">
						<div class="rounded-20 p-40 flex-1 mr-10" style="background-color: #441201;">
							<div>
								<span class="text-26 text-#ccc">{{$t('NFT权益.我的NFT')}}</span>
							</div>
							<div class="mt-30">
								<span class="text-36 text-white font-bold">{{nft_count}}</span>
							</div>
						</div>
						<div class="ml-10 rounded-20 p-40 flex-1" style="background-color: #441201;">
							<div>
								<span class="text-26 text-#ccc">质押中</span>
							</div>
							<div class="mt-30">
								<span class="text-36 text-primary font-bold">{{nft_staking_count}}</span>
<!--								<span class="text-28 text-primary font-bold">ROON</span>-->
							</div>
						</div>
					</div>

				</div>
				<div class=" my-30 flex items-center justify-between rounded-22 h-90 bg-white/10">
					<div @click="setQueryInfo(1)" :class="[queryInfo.type == 1 ? 'bg-primary' : '']" class="rounded-22 flex-1 h-90 flex items-center justify-center">
						<span class="text-32 text-white">{{$t('NFT权益.我的NFT')}}</span>
					</div>
<!--					<div @click="setQueryInfo(2)" :class="[queryInfo.type == 2 ? 'bg-primary' : '']" class="rounded-22 flex-1 h-90 flex items-center justify-center">-->
<!--						<span class="text-32 text-white">{{$t('NFT权益.矿机NFT')}}</span>-->
<!--					</div>-->
					<div @click="setQueryInfo(3)" :class="[queryInfo.type == 3 ? 'bg-primary' : '']" class="rounded-22 flex-1 h-90 flex items-center justify-center">
						<span class="text-32 text-white">质押中</span>
					</div>
				</div>
				<!-- 节点NFT -->
				<div v-if="queryInfo.type == 1" class="">
					<div v-for="(item, index) in nfts.filter(n => Number(n.balance) > 0)" :key="item.id || index" class="mb-20 rounded-20 p-30 bg-white/10">
						<div class="flex items-center">
							<img class="w-88 h-88" :src="item.img" alt="" />
							<div class="ml-20 flex-1">
								<div class="flex items-center justify-between">
									<span class="text-36 text-white">{{item.name}}</span>
<!--									<div v-if="index > 0" class="px-20 h-42 rounded-12 flex items-center justify-center border border-solid"-->
<!--										style="border-color:#42FF6E; background-color: #42FF6E20;">-->
<!--										<span class="text-20" style="color: #42FF6E;">{{$t('NFT权益.已拥有')}}</span>-->
<!--									</div>-->
								</div>
								<div class="mt-10 flex items-center">
									<div class="px-20 h-42 rounded-12 flex items-center justify-center border border-solid"
										style="border-color:#D27DFF; background-color: #D27DFF20;">
										<span class="text-20" style="color: #D27DFF;">剩余：{{item.balance}}</span>
									</div>
								</div>
							</div>
						</div>
						<div class="mt-30 bg-white/10 rounded-20 p-30">
<!--							<div>-->
<!--								<span class="text-24 text-#999">{{$t('NFT权益.专属权益')}}</span>-->
<!--							</div>-->
							<div class="mt-10">
								<span class="text-26 text-white">{{item.synopsis}}</span>
							</div>
<!--							<div class="mt-10">-->
<!--								<span class="text-26 text-white">{{$t('NFT权益.优先提现权')}}</span>-->
<!--							</div>-->
<!--							<div class="mt-10">-->
<!--								<span class="text-26 text-white">{{$t('NFT权益.治理投票权')}}</span>-->
<!--							</div>-->
<!--							<div class="mt-10">-->
<!--								<span class="text-26 text-white">{{$t('NFT权益.专属客服')}}</span>-->
<!--							</div>-->
						</div>
<!--						<div class="flex items-center justify-between mt-30">-->
<!--							<div class="flex-1 text-center">-->
<!--								<div>-->
<!--									<span class="text-20 text-#999">{{$t('NFT权益.价格')}}</span>-->
<!--								</div>-->
<!--								<div class="mt-10">-->
<!--									<span class="text-36 font-bold" style="color: #9646FF;">$50,000</span>-->
<!--								</div>-->
<!--							</div>-->
<!--							<div class="w-2 h-30 bg-white/10"></div>-->
<!--							<div class="flex-1 text-center">-->
<!--								<div>-->
<!--									<span class="text-20 text-#999">{{$t('NFT权益.总量')}}</span>-->
<!--								</div>-->
<!--								<div class="mt-10">-->
<!--									<span class="text-36 font-bold" style="color: #9646FF;">10</span>-->
<!--								</div>-->
<!--							</div>-->
<!--							<div class="w-2 h-30 bg-white/10"></div>-->
<!--							<div class="flex-1 text-center">-->
<!--								<div>-->
<!--									<span class="text-20 text-#999">{{$t('NFT权益.剩余')}}</span>-->
<!--								</div>-->
<!--								<div class="mt-10">-->
<!--									<span class="text-36 font-bold" style="color: #9646FF;">3</span>-->
<!--								</div>-->
<!--							</div>-->
<!--						</div>-->
						<div v-if="item.balance > 0" class="mt-40 rounded-full flex items-center justify-center bg-primary h-100" @click="staking(item)">
							<span class="text-white text-32">质押</span>
						</div>
<!--						<div v-else class="mt-40 rounded-full flex items-center justify-center bg-white/10 h-100">-->
<!--							<span class="text-white text-32">{{$t('NFT权益.已拥有')}}</span>-->
<!--						</div>-->
					</div>
				</div>
				<!-- 矿机NFT -->
				<div v-else-if="queryInfo.type == 2" class="">
					<div v-for="(item, index) in nfts.filter(n => Number(n.balance) > 0)" :key="item.id || index" class="rounded-20 p-20 bg-white/10 mb-20" >
						<div class="flex items-center">
							<img class="w-88 h-88" src="@/assets/images/pages/nft/kj.png" alt="" />
							<div class="ml-20 flex-1">
								<div class="flex items-center justify-between">
									<span class="text-36 text-white">黄金矿机</span>
									<div v-if="index > 0" class="px-20 h-42 rounded-12 flex items-center justify-center border border-solid"
										style="border-color:#42FF6E; background-color: #42FF6E20;">
										<span class="text-20" style="color: #42FF6E;">{{$t('NFT权益.已拥有')}}</span>
									</div>
								</div>
								<div class="mt-10 flex items-center">
									<div class="px-20 h-42 rounded-12 flex items-center justify-center border border-solid"
										style="border-color:#FF9144; background-color: #FF914420;">
										<span class="text-20" style="color: #FF9144;">史诗</span>
									</div>
								</div>
							</div>
						</div>
						<div class="mt-30 bg-white/10 rounded-20 p-30 flex items-center justify-between">
							<div class="flex-1">
								<div>
									<span class="text-24 text-#999">{{$t('NFT权益.算力')}}</span>
								</div>
								<div class="mt-10">
									<span class="text-26 text-white">500  TH/s</span>
								</div>
							</div>
							<div class="flex-1">
								<div>
									<span class="text-24 text-#999">{{$t('NFT权益.日产出')}}</span>
								</div>
								<div class="mt-10">
									<span class="text-24 text-primary font-bold">25 ROON</span>
								</div>
							</div>
						</div>
						<div class="flex items-center justify-between mt-30">
							<div class="flex-1 text-center">
								<div>
									<span class="text-20 text-#999">{{$t('NFT权益.价格')}}</span>
								</div>
								<div class="mt-10">
									<span class="text-36 font-bold" style="color: #EB470C;">$50,000</span>
								</div>
							</div>
							<div class="w-2 h-30 bg-white/10"></div>
							<div class="flex-1 text-center">
								<div>
									<span class="text-20 text-#999">{{$t('NFT权益.总量')}}</span>
								</div>
								<div class="mt-10">
									<span class="text-36 font-bold" style="color: #EB470C;">10</span>
								</div>
							</div>
							<div class="w-2 h-30 bg-white/10"></div>
							<div class="flex-1 text-center">
								<div>
									<span class="text-20 text-#999">{{$t('NFT权益.剩余')}}</span>
								</div>
								<div class="mt-10">
									<span class="text-36 font-bold" style="color: #EB470C;">3</span>
								</div>
							</div>
						</div>
						<div v-if="index == 0" class="mt-40 rounded-full flex items-center justify-center bg-primary h-100">
							<span class="text-white text-32">{{$t('NFT权益.立即购买')}}</span>
						</div>
						<div v-else class="mt-40 rounded-full flex items-center justify-center bg-white/10 h-100">
							<span class="text-white text-32">{{$t('NFT权益.已拥有')}}</span>
						</div>
					</div>
				</div>
				<!-- 我的NFT -->
				<div v-else-if="queryInfo.type == 3" class="">
					<div v-for="(item, index) in nft_stakings" :key="index" class="bg-white/10 rounded-20 p-30 mb-20">
						<div class="flex items-center">
							<img  class="w-88 h-88" :src="item.token.img" alt="" />
							<div class="ml-20 flex-1">
								<div class="flex items-center justify-between">
									<span class="text-36 text-white">{{item.token.name}}</span>
									<span class="text-24 text-#999">质押时间</span>
								</div>
								<div class="mt-10 flex items-center justify-between">
<!--									<div v-if="index == 0" class="px-20 h-42 rounded-12 flex items-center justify-center border border-solid"-->
<!--										style="border-color:#7901B7; background-color: #7901B720;">-->
<!--										<span class="text-20" style="color: #7901B7;">B级</span>-->
<!--									</div>-->
									<div class="px-20 h-42 rounded-12 flex items-center justify-center border border-solid" style="border-color:#FF9144; background-color: #FF914420;">
										<span class="text-20" style="color: #FF9144;">数量：1</span>
									</div>
									<span class="text-26 text-primary font-bold">{{item.stake_date}}</span>
								</div>
							</div>
						</div>
						<div v-if="item.status == 0" class="mt-40 rounded-full flex items-center justify-center bg-white/10 h-100" @click="extract(item)">
							<span class="text-white text-32">解压</span>
						</div>
                        <div v-else class="mt-40 rounded-full flex items-center justify-center bg-white/10 h-100" >
                            <span class="text-white text-32">解压中</span>
                        </div>
					</div>
				</div>

                <div class="mt-20 bg-white/10 rounded-20 p-30" style="background-color: #19191A;">
                    <div class="">
                        <span class="text-white text-36">{{$t("NFT权益.NFT权益说明")}}</span>
                    </div>
                    <div class="mt-20 bg-white/10 rounded-20 p-30">
                        <div class="py-10 flex items-center">
                            <div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
                            <span class="ml-20 text-24 text-#ccc">{{$t("NFT权益.节点NFT提供额外收益加成和治理权")}}</span>
                        </div>
                        <div class="py-10 flex items-center">
                            <div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
                            <span class="ml-20 text-24 text-#ccc">{{$t("NFT权益.矿机NFT提供持续的挖矿产出")}}</span>
                        </div>
                        <div class="py-10 flex items-center">
                            <div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
                            <span class="ml-20 text-24 text-#ccc">{{$t("NFT权益.所有NFT权益永久有效")}}</span>
                        </div>
                    </div>
                </div>

			</div>
		</template>
		<template v-slot:menuBar>
			<!-- <menu-bar activeMenu="node"></menu-bar> -->
		</template>
		<template v-slot:popup>
			<van-overlay :show="paying" :z-index="9999" class-name="flex items-center justify-center">
				<div class="flex flex-col items-center justify-center">
					<van-loading size="24px" vertical color="#1989fa">Transaction in progress...</van-loading>
				</div>
			</van-overlay>
		</template>
	</page-content>
</template>

<script>
	import {
		ajaxData
	} from "@/request/ajax";
	import homeNav from '@/components/home-nav/home-nav.vue';
	import menuBar from '@/components/menu-bar/menu-bar.vue';
	import router from "@/router";
	import utils from "@/utils/utils.js";
	import store from "@/store/index.js";
	import nodeNft from "@/abi/nodeNftAbi"
	import SimpleERC1155StakingAbi from "@/abi/SimpleERC1155StakingAbi"
	import Mining_Abi from "@/abi/MiningAbi";
	import {
		getShowAddress,
		setShowAddress
	} from "@/libs/util";
	import Web3 from "web3";
	export default {
		components: {
			homeNav,
			menuBar,
		},
		data() {
			return {
				triggered: false,
				more: 1,
				typeList: [],
                nft_stakings: [],
				queryInfo: {
					page: 1,
					type: 1
				},
				min_number: 0,
                nft_staking_count: 0,
                nft_count: 0,
				node_allocate: 0,
				node_release: 0,
				contract_address: "0x027e7dE1469E0fd88e5EE4b5AebB596a0cb7e1C6",
                nft_staking_address: "0xC8b9755f01ccc17922a76c201cBE4Ef3e088b22F",
				address: "",
				web3Provider: null,
				web3: null,
				list: [],
				nfts: [],
				showAmountPopup: false,
				// 支付进行中的不可关闭 loading 遮罩
				paying: false,
				canGo: true,
			};
		},
		computed: {
			lang() {
				return store.state.language;
			},
			activeType() {
				let item = {};
				item = this.typeList.find(item => item.id == this.queryInfo.type) || {};
				return item;
			},
			activeAmount() {
				let item = {};
				item = this.amountList.find(item => item.id == this.form.amount_id) || {};
				return item;
			}
		},
		created() {
			let vm = this
			if (window.ethereum) {
				vm.web3Provider = window.ethereum
				vm.web3 = new Web3(vm.web3Provider);


			}
			vm.getList();
		},
		methods: {
			goToLock() {
				this.$router.push({
					path: '/lock'
				})
			},
            async test() {
                let vm = this
                const stakingContract = new vm.web3.eth.Contract(SimpleERC1155StakingAbi, vm.nft_staking_address);


                const ids = await stakingContract.methods.getUserActiveStakeIdsByScenario(vm.address, 1).call();
                console.log("getUserActiveStakeIdsByScenario",ids)

            },
            async extract(item) {
				const vm = this;
				if (!vm.web3) return;
				if (!vm.address) return;

				vm.paying = true;
				try {
                    // 先调用后端接口，成功后再继续链上交易
                    try {
                        const resp = await ajaxData("/nft/remove", { id: item.id });
                        console.log("/nft/remove resp", resp);
                    } catch (apiErr) {
                        console.error("/nft/remove error", apiErr);
                        vm.$message.error(apiErr?.message || vm.$t("吐司.操作失败"));
                        vm.paying = false;
                        return; // 接口异常直接结束，不继续链上操作
                    }

					const stakingContract = new vm.web3.eth.Contract(SimpleERC1155StakingAbi, vm.nft_staking_address);
					await stakingContract.methods.unstake(item.stake_id).send({
						from: vm.address
					});

                    vm.$message.success("操作成功，请稍后刷新查看")
					// Refresh data
					vm.getList();
				} catch (e) {
					console.error("Unstaking error:", e);
				} finally {
					vm.paying = false;
				}
            },
            async staking(item) {
				const vm = this;
				if (!vm.web3) return;
				if (!vm.address) return;

				vm.paying = true;
				try {
					// 1. Check if approved
					const nftContract = new vm.web3.eth.Contract(nodeNft, vm.contract_address);
					const isApproved = await nftContract.methods.isApprovedForAll(vm.address, vm.nft_staking_address).call();

					if (!isApproved) {
						await nftContract.methods.setApprovalForAll(vm.nft_staking_address, true).send({
							from: vm.address
						});
					}



					// 2. Call stake
					const stakingContract = new vm.web3.eth.Contract(SimpleERC1155StakingAbi, vm.nft_staking_address);


                    const ids = await stakingContract.methods.getUserActiveStakeIdsByScenario(vm.address, 1).call();
                    console.log("getUserStakeIdsByScenario",ids)
                    if (ids.length > 0) {
                        vm.$message.error("您已经质押");
                        vm.paying = false;
                        return;
                    }


					await stakingContract.methods.stake(item.id, 1, 1).send({
						from: vm.address
					});

                    vm.$message.success("操作成功，请稍后刷新查看")
					// Refresh data
					vm.getList();
				} catch (e) {
					console.error("Staking error:", e);
				} finally {
					vm.paying = false;
				}
            },
            async getList() {
				let vm = this
				getShowAddress()
				ajaxData("/nft").then(res => {
					console.log(res)
					vm.address = res.data.address;
					vm.nfts = res.data.nfts;
					vm.nft_stakings = res.data.nft_stakings;

                    vm.nft_staking_count = vm.nft_stakings.length
                    vm.getUserNfts()

                    // vm.test()
				})
			},
			async getUserNfts() {
				const vm = this;
				try {
					if (!vm.web3) {
						console.warn('Web3 provider is not initialized.');
						return;
					}
					if (!vm.contract_address) {
						console.warn('Contract address is missing.');
						return;
					}
					const contract = new vm.web3.eth.Contract(nodeNft, vm.contract_address);
					console.log("vm.address",vm.address)
					const data = await contract.methods.getUserNodes(vm.address).call();
					console.log('getUserNodes result:', data);
					const nodeIds = (data && (data.nodeIds || data[0])) || [];
					const amounts = (data && (data.amounts || data[1])) || [];
					const idToAmount = new Map();
					let totalCount = 0;
					for (let i = 0; i < nodeIds.length; i++) {
						const key = String(nodeIds[i]);
						const val = amounts[i];
						const strVal = (val && val.toString) ? val.toString() : (val ?? '0');
						idToAmount.set(key, strVal);
						totalCount += Number(strVal);
					}
					vm.nft_count = totalCount;
					vm.nfts = (vm.nfts || []).map(item => {
						const bal = idToAmount.get(String(item.id)) ?? '0';
						return { ...item, balance: bal };
					});
                    console.log("nfts",vm.nfts)
				} catch (err) {
					console.error('Failed to fetch user NFTs from contract:', err);
				}

            },
			async getUserNodePurchaseStatus() {
				const vm = this;
				const contract = new vm.web3.eth.Contract(Mining_Abi, vm.mining_contract);
				let data = await contract.methods.getUserNodePurchaseStatus(vm.address).call();
				console.log(data)
				console.log(data.nodeCount)
			},
			setQueryInfo(type) {
				this.queryInfo.type = type;
				// this.form.type = type;
			},
			selectAmount(number) {
				this.form.amount = parseInt(number);
				this.form.dd_roon = this.form.amount / 20;

				// this.form.amount_id = item.id;
				// this.showAmountPopup = false;
			},
			scrolltolower() {
				console.log("滚动到底部/右边");
				this.triggered = true;
				setTimeout(() => {
					this.more = 0;
					this.triggered = false;
				}, 1000)
			},
			refresherpulling() {
				this.triggered = true;
				setTimeout(() => {
					this.triggered = false;
				}, 200)
				console.log("下拉刷新");
			}
		},
	};
</script>

<style scoped>

	.nft-item1-bg-image {
		width: 690rem;
		height: 340rem;
		background-image: url("~@/assets/images/pages/nft/itemBg1.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}

	.dividend-pool-item1-bg-image {
		width: 690rem;
		height: 420rem;
		background-image: url("~@/assets/images/pages/dividend-pool/itemBg1.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}


	.dividend-pool-item2-bg-image {
		width: 690rem;
		height: 420rem;
		background-image: url("~@/assets/images/pages/dividend-pool/itemBg2.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}

</style>





